export enum FormSendType {
  ENDGAME = 'endgame contact form',
  CONTACT_US = 'contact us form'
}
